import { useLocation } from '@tanstack/react-router'
import React from 'react'

import { getSelectedTab } from './getSelectedTab'
import { Homebar } from './Homebar'
import { useNavbarConfig } from './useNavbarConfig'
import { useNavbarData } from './useNavbarData'

export const Navbar: React.FC<{
  orgOrSiteID?: string
  defaultClosed?: boolean
  hideSiteSelector?: boolean
  hideSearchBar?: boolean
  hideMenuButton?: boolean
}> = ({
  orgOrSiteID,
  hideSiteSelector = false,
  hideSearchBar = false,
  hideMenuButton = false,
}) => {
  const location = useLocation()

  const {
    site,
    sites,
    sitesForOrg,
    organization,
    organizations,
    isLoading,
    hasEverLoaded,
  } = useNavbarData(orgOrSiteID)

  const { showHomebarSearch } = useNavbarConfig({
    orgId: organization?.id ?? '',
    siteId: site?.id,
  })

  const shouldHideSiteSelector = hideSiteSelector
  const shouldHideSearchBar = hideSearchBar || !showHomebarSearch

  const selectedTab = getSelectedTab(location.pathname + location.search)

  return (
    <Homebar
      hideSiteSelector={shouldHideSiteSelector}
      hideSearchBar={shouldHideSearchBar}
      hideMenuButton={hideMenuButton}
      selectedOrganization={organization}
      organizations={organizations}
      selectedSite={site}
      sites={sites}
      sitesForOrg={sitesForOrg}
      isLoading={isLoading}
      hasEverLoaded={hasEverLoaded}
      selectedTab={selectedTab}
    />
  )
}
